/**
 * Display casing for extracted criterion titles.
 *
 * Tenders shout: a criterion arrives as `CAPABILITY AND EXPERIENCE` more often
 * than not, and a table of all-caps rows is unreadable. This lives in `lib/`
 * rather than beside the table because both the table and `CriterionDrawer`
 * need it, and importing it from the table would close a cycle between them.
 */

/** Domain acronyms that must keep their casing when ALL-CAPS runs are title-cased. */
const PRESERVED_ACRONYMS = new Set([
  'VIPP', 'OHS', 'ITT', 'RFT', 'RFP', 'RFQ', 'LIDP', 'SQE', 'ADWG', 'QA', 'QMS',
  'WHSE', 'HSEQ', 'HAZOP', 'CHAZOP', 'ISO', 'PMP', 'PEP', 'DAF', 'D&C', 'O&M',
])

/** Convert ALL CAPS text to Title Case, preserving already-mixed-case segments and known acronyms */
export function normalizeTitle(text: string): string {
  return text.replace(/[A-Z&]{2,}(?:\s+[A-Z&]{2,})*/g, (match) =>
    match
      .split(/\s+/)
      .map((word) =>
        PRESERVED_ACRONYMS.has(word)
          ? word
          : word.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
      )
      .join(' ')
  )
}
